"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideo = void 0;
const immutable_1 = require("immutable");
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const adAnalyticsMedia_1 = require("./AdAnalyticsPlacementTypes/adAnalyticsMedia");
const adAnalyticsPlacement_1 = require("./AdAnalyticsPlacementTypes/adAnalyticsPlacement");
const adAnalyticsPlatform_1 = require("./AdAnalyticsPlacementTypes/adAnalyticsPlatform");
const adAnalyticsVideoIndex_1 = require("./adAnalyticsVideoIndex");
const project_1 = require("./project");
const createSomeAdAnalyticsVideo = ({ adVideoId = '456', analyzingState = 'processed', title = 'title', project = project_1.createSomeProject(), platforms = immutable_1.List([adAnalyticsPlatform_1.createAdAnalyticsPlatform()]), medias = immutable_1.List([adAnalyticsMedia_1.createAdAnalyticsMedia()]), placements = immutable_1.List([adAnalyticsPlacement_1.createAdAnalyticsPlacement()]), impressions = 100, clicks = 10, currency = 'JPY', spend = 100, mobileAppInstalls = 100, conversions = 0.2, conversionsKey = 'reach', viewThroughConversions = 0.01, cvr = 1, ctr = 0.05, cpc = 0.05, cpm = 0.05, cpa = 0.05, cpaWithViewThroughConversions = 0.05, duration = 30, videoUrl = 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4', thumbnailImageUrl = 'http://placehold.it/400x300', adAnalyticsVideoIndex = adAnalyticsVideoIndex_1.createSomeAdAnalyticsVideoIndex(), } = {}) => new AdAnalyticsVideo_1.default({
    adVideoId,
    analyzingState,
    title,
    project,
    platforms,
    medias,
    placements,
    impressions,
    clicks,
    currency,
    spend,
    mobileAppInstalls,
    conversions,
    conversionsKey,
    viewThroughConversions,
    cvr,
    ctr,
    cpc,
    cpm,
    cpa,
    cpaWithViewThroughConversions,
    duration,
    videoUrl,
    thumbnailImageUrl,
    adAnalyticsVideoIndex,
});
exports.createSomeAdAnalyticsVideo = createSomeAdAnalyticsVideo;
